/**
 *
 * @module orderStatusResponse
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef OrderStatusResponse
 * @type {Object}
 *
 * @property {String} success
 * @property {String} badRequest
 * @property {String} timeout
 * @property {String} unprocessable
 * @property {String} undetermined
 *
 */

/**
 *
 * @enum
 * @type {OrderStatusResponse}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Success: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    BadRequest: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Timeout: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Unprocessable: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Undetermined: null
});



// WEBPACK FOOTER //
// ./src/services/commerce/orderStatusResponse.js